<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  <div class='sheet'>
    <h1 class='header'>Create a new vehicle</h1>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-tabs>
        <app-tab title='Vehicle Details'>
          <app-vehicle-form [vehicle]='this.vehicle'></app-vehicle-form>
        </app-tab>

        <app-tab title='Workshop Details'>
          <app-vehicledetail-form [vehicleDetails]='this.vehicle.detail' [vehicle]='this.vehicle' [inspectionAssignments]='this.inspectionAssignments' [edit]='false'></app-vehicledetail-form>
        </app-tab>

        <app-tab title='Asset Details'>
          <app-asset-form [vehicle]='this.vehicle' [formSettings]='this.formSettings'></app-asset-form>
        </app-tab>
        <app-tab title='DVLA Importer'>
          <app-dvla-reg [vehicle]='this.vehicle'></app-dvla-reg>
        </app-tab>
      </app-tabs>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/vehicles'>Cancel</button>
    </form>
  </div>
</div>
